<template>
  <div id="about">
  <transition appear name="about">
<div class="container">
  <div class="columns">
    <div class="has-text-left column is-three-fifths ml-10 mr-10">
      <h1 class="subtitle"><span class="underline">夕焼け予報について</span></h1>
      <p class="mb-20">
      このWebサイトは、今日明日の夕焼けがどの程度綺麗になるかを事前に予測し、その結果を記載している研究目的のWebサイトです。
      <!-- 2015年に作ろうと思い立ってから、完成させるのに4年もかけてしまいました。<br> -->
      <!--予測には機械学習を用いて気象情報(雲の位置や量、水蒸気量など)から景観推定を行っており、予測結果を「厳しい、普通、好条件」のいずれかに割り当てています。-->
      <!--2020年6月頃HDDを誤って消してしまい停止していましたが、現在(2020年9月以降)は復旧しています。-->
      </p>

      <p class="mb-40">
         2020年6月頃HDDを誤って消してしまい停止していましたが、予測モデルを作り直して復旧しました。(2020年11月)<br>
         <!--これからは地道にブラッシュアップをしていく予定です。今の時期は日の入りが早い分予測にズレが生じてしまっているので、次はその辺りから...-->
      </p>

      <h2 class="subtitle"><span class="underline">夕焼けを見るときのポイント</span></h2>
      <p class="mb-40">
        綺麗な夕焼けが見たいのならば、<span class="blue">日が沈む時間の10分前後</span>が狙い目です。<br>
        とはいえ日が沈んで30分後に綺麗になる場合もあるので、夕焼けは気まぐれですね。
      </p>

      <h2 class="subtitle"><span class="underline">予測方法について</span></h2>
      <p class="mb-20">
        予測には気象情報(雲の量や位置、湿度、温度など)から機械学習を用いて景観推定を行っており、予測結果を「厳しい、普通、好条件」のいずれかに割り当てています。<br>
        
      </p>
      <p class="mb-20">
        この夕焼け予報自体は最小構成でとりあえず完成させたものなので、予報の精度は今のところはほどほどです。<br>
        夕焼けを見ようと思っている日の昼間に、空が青くかつ雲が適量あるかを目視で確認するのと予測精度は恐らく大差ないでしょう。<br>
        <b>予測結果はそれを保証するものではないことをご了承ください。</b>
      </p>
      <p class="mb-40">
        予報を作る際に用いたデータの大半が名古屋(名古屋大学)で観測したものなので、<span class="blue">東京よりも名古屋の方が当たりやすい</span>と思います。<br>
        また現在は今日明日の二日分しか予報を出していませんが、いずれ一週間後くらいまで予報するようにしたいなと思っています。<br>
        ただ現在の気象予測では次の日の雲の形ですら正確に予測するのは難しいので、実現はもうすこし先の話かなとは思います。
      </p>

      <h2 class="subtitle"><span class="underline">予測頻度について</span></h2>
      <p class="mb-40">
        以下の時刻に予測情報の更新を行なっています。
        <ul class="mb-5 mt-5">
          <li>・3時過ぎ  - 前日21時の気象図からの予測</li>
          <li>・9時過ぎ  - 当日3時の気象図からの予測 [New!]</li>
          <li>・15時過ぎ - 当日9時の気象図からの予測</li>
          <li>・18時過ぎ - 当日12時の気象図からの予測</li>
        </ul>
        <s>更新頻度が少ないのとタイムラグがあるのは金銭的に厳しいからだったりします...</s>
      <br>
      <br>
        24/7/13<br>
        一時的にサーバー増強して朝9時にも予測処理を追加しました。<br>
        ちょっと様子見してこの構成を続けるか考えようと思います。
      </p>
      <div>
      <router-link to="/" class="mt-10">
          <span class="blue">トップへ戻る</span>
      </router-link>
      </div>
      <br><br>
    </div>
</div>
</div>
  </transition>
  <transition appear>
   <div class="background" v-if="!phone" :style="{ 'background-image': `url(${backgroundImage})` }"></div>
  </transition>
  </div>
  
</template>


<script>
import BackgroundImage from "@/assets/images/background.png";
import Mobile from 'ismobilejs'

//       <h2 class="subtitle"><span class="underline">ヘルプ募集中</span></h2>
        
//      <p class="mb-40">
//        精度を向上させるため、ただいま<span class="blue">全国各地での夕焼けの観測データ</span>を必要としています。<br>
//        助けてあげてもいいよ！という心優しい方がいたら、<a href="https://www.7rpn.net/#/contact">Contactページ</a>よりご連絡ください。
//      </p>

export default {
  name: 'About',
  data () {
    return {
      backgroundImage: BackgroundImage,
      phone: false
    }
  },
  created() {
  }, 
  mounted(){
    if (Mobile.phone){
      this.phone = true
    }
  },
  methods:{
  },
  watch: {
    '$route' (to, from) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.about-enter-active{
  transition: all .7s .2s;
}
.about-leave-active{
  transition: all .7s .0s;
}
.about-enter, .about-leave-to{
  opacity: 0;
}
span.underline{
  border-bottom: solid 2px rgb(180,250,215);
  padding-bottom: 0px;
}
span.blue{
  color: rgb(80,160,235)
}
p{
  text-align: justify;

}

div.background{
  content:"";
  display:block;
  position: fixed;
  z-index:-2;
  top:0;
  left:50vw;
  width: 40vw;
  height:100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  opacity:0.15;
}



@media screen and (max-width: 550px) {
  p{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue